import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import {DateDisplay} from "../Extra/DateDisplay";
import {UrlFixer} from "../../utils/utils";
import { MarkdownDisplay } from '../Extra/MarkdownDisplay';
import { StyledArticleItem, StyledArticleItemThumb, StyledArticleItemTitle } from "../../utils/common-styles";

export const ArticleListItem = (props) => {

    const navigate = useNavigate();
    const article = props.article;

    function clickHandler(id, slug) {
        let url = '/articles/' + id + '/' + slug;
        navigate(url);
    } 

    return (
        <StyledArticleItem onClick={(e) => clickHandler(article.id, article.slug)}>
            <Row>
                <Col xs={12} md={6}>
                    <StyledArticleItemThumb>
                        <img src={UrlFixer(article.image_details.variations.home_list_item_small)} alt={article.title}/>
                    </StyledArticleItemThumb>
                </Col>
                <Col xs={12} md={6}>
                    <StyledArticleItemTitle>
                        <h5><a href={"/articles/" + article.id + "/" + article.slug}>{article.title}</a></h5>
                        <ul className="post-meta">
                            <li><span>Posted:</span><DateDisplay datetime={article.published_at}/></li>
                        </ul>
                        <MarkdownDisplay text={article.intro} plugins={[]}/>
                    </StyledArticleItemTitle>
                </Col>
            </Row>
        </StyledArticleItem>   
    )
}